"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../../index");
const GetExchangePrices_1 = require("./calls/GetExchangePrices/GetExchangePrices");
class IAPIExchangeClient extends index_1.IAPIClient {
    constructor(params) {
        super(params);
        this.getExchangePrices = GetExchangePrices_1.getExchangePrices.bind(this);
    }
}
exports.default = IAPIExchangeClient;
